





































import { Vue, Component, Watch } from "vue-property-decorator";
import { StoreState } from "../store";
import { mapState } from "vuex";

@Component({
  computed: {
    ...mapState({
      conferenceattendeesectionlist: (state: StoreState) => state.dashboard.AttendeeSectionList
       })
  }
})
export default class ComboboxConference extends Vue {
  private conferenceattendeesectionlist: any[];
  data() {
    return {
      notFound: "",
      collector: "",
      defaults: true,
      handleSelectedArea: false,
      displayList: false,
      showSelected: [],
      getLabel: [],
      datum: {},
      backupDatum: {}
    };
  }





  @Watch("conferenceattendeesectionlist", { immediate: true })
  async onConferenceattendeesectionlistChanged(value) {
    const valued = { ...value };
    for (const obj in valued) {
      for (const [index, ob] of valued[obj].entries()) {
        ob.selected = false;
      }
    }
    this.$data.datum = valued;
    this.$data.backupDatum = { ...valued };
    this.$emit("finalSelected", this.$data.showSelected);
  }


  search_inputblur(){
     this.$data.notFound ="";
    //alert('search_inputblur')
      this.getLabled();
      this.updatedViewList();
      //this.initClick();
  }
 get notFound123(){
   //this.$data.notFound='';
   //console.log(this.$data.notFound)
   return this.$data.notFound;
 }


  mounted() {
    // Listen to all clicks on the document
    document.addEventListener("click", (event: any) => {
      // If the click inside the element, do nothing
      if (event.target.closest(".combo-major")) return;

      // If the clicks outside the element, hide it!
      this.$data.displayList = false;
      if (this.$data.showSelected.length > 0) {
        if (!this.$data.showSelected[0].label) {
          this.$data.defaults = true;
          this.$data.handleSelectedArea = false;
        }
      }
    });
  }
  
  resetStartCallModal() {
    this.$data.showSelected = [];
    this.$data.displayList = false;
    this.$data.defaults = true;
    this.$data.handleSelectedArea = false;
    for (const obj in this.$data.datum) {
      for (const [index, ob] of this.$data.datum[obj].entries()) {
        ob.selected = false;
      }
    }
  }

  checkAutoFocus() {
    this.$nextTick(() => {
      if (!document.getElementById("emptyInput")["autofocus"])
        document.getElementById("emptyInput").focus();
    });
  }

  unSelectItem(user, callback) {
    breakLoop: for (const catgry in this.$data.datum) {
      for (const item of this.$data.datum[catgry]) {
        if (item.label === user) {
          item.selected = false;
          break breakLoop;
        }
      }
    }
    callback();
  }

  getLabled() {
    this.$data.getLabel = [];
    this.$data.showSelected.map(obj => {
      if (obj.label) this.$data.getLabel.push(obj.label);
    });
  }

  validKeyPress(keycode) {
    var valid =
      (keycode > 47 && keycode < 58) || // number keys
      keycode == 32 ||
      keycode == 13 || // spacebar & return key(s) (if you want to allow carriage returns)
      (keycode > 64 && keycode < 91) || // letter keys
      (keycode > 95 && keycode < 112) || // numpad keys
      (keycode > 185 && keycode < 193) || // ;=,-./` (in order)
      (keycode > 218 && keycode < 223); // [\]' (in order)
    return valid;
  }

  updatedViewList() {
    this.getLabled();
    const backup = JSON.parse(JSON.stringify(this.$data.backupDatum));
    for (const catgry in backup) {
      for (const obj of backup[catgry]) {
        if (this.$data.getLabel.includes(obj.label)) {
          obj.selected = true;
        }
      }

      let cEmpty = 0;
      if (this.$data.collector.length>0){
      const filteredArray = JSON.parse(
        JSON.stringify(backup[catgry])
      ).filter(
        o =>
          o.label.toLowerCase().indexOf(this.$data.collector.toLowerCase()) > -1
      );
     backup[catgry]=filteredArray;

    }
      }
     
     
    this.$data.datum = backup;
  }

  initClick() {
    this.$data.showSelected = [];
    this.$data.displayList = true;
    this.$data.defaults = false;
    this.$data.handleSelectedArea = true;
    this.$data.notFound ="";
    this.$data.collector='';
    this.$data.showSelected.push({ label: "" });
    this.checkAutoFocus();
    this.updatedViewList();
  }

  clickArea(e) {
    if (e.which !== 8) {
      this.checkAutoFocus();
      this.updatedViewList();
      this.$data.displayList = true;
    }
  }

  clickBackspace(event) {
    debugger;
    this.$data.displayList = true;
    this.$data.notFound = "";
    const g = document.getElementById("emptyInput")["value"];
    if(event.key=="Enter" && event.code=="Enter"){
     //alert('"Enter" ')
    }
    else{

    if (this.validKeyPress(event.keyCode)) {
      this.$data.collector = this.$data.collector + event.key;
    } else if (event.which === 8 && this.$data.collector) {
      this.$data.collector = this.$data.collector.substring(
        0,
        this.$data.collector.length - 1
      );
    } else if (
      !this.$data.collector &&
      event.which === 8 &&
      this.$data.showSelected.length > 1
    ) {
      const cpArr = this.$data.showSelected;
      const arrFilter = this.$data.showSelected.splice(cpArr.length - 2, 1);
      this.unSelectItem(arrFilter[0].label, this.checkAutoFocus);
    } else {
      this.$data.displayList = false;
    }
    this.getLabled();
    let cEmpty = 0;
    for (const obj in this.$data.backupDatum) {
      this.$data.datum[obj] = [];
      const filteredArray = JSON.parse(
        JSON.stringify(this.$data.backupDatum[obj])
      ).filter(
        o =>
          o.label.toLowerCase().indexOf(this.$data.collector.toLowerCase()) > -1
      );
      if (filteredArray.length === 0) {
        cEmpty++;
      } else {
        filteredArray.map(o => {
          if (this.$data.getLabel.includes(o.label)) {
            o.selected = true;
          }
        });
      }
      this.$data.datum[obj] = filteredArray;
    }
    if (cEmpty === Object.keys(this.$data.backupDatum).length) {
      this.$data.displayList = false;
      this.$data.notFound = this.$data.collector;
    }
    this.$emit("finalSelected", this.$data.showSelected);
    if (!this.$data.notFound && this.$data.showSelected.length == 1)
      this.$data.displayList = true;
    }

  }

  itemSelect(item) {
    document.getElementById("emptyInput")["value"] = "";
    this.$data.collector = "";
    if (item.selected) return;
    const arrFilter = this.$data.showSelected.filter(v => v.label);
    this.$data.showSelected = [];
    this.$data.showSelected = [...arrFilter, item, { label: "" }];
    this.$data.displayList = false;
    this.$emit("finalSelected", this.$data.showSelected);
    this.updatedViewList();
    this.checkAutoFocus();
  }

  removeSelect(item) {
    document.getElementById("emptyInput")["value"] = "";
    this.$data.collector = "";
    this.$data.showSelected = this.$data.showSelected.filter(
      v => v.label != item.label
    );
    this.$data.displayList = false;
    this.$data.notFound = "";
    this.getLabled();
    this.updatedViewList();
    this.unSelectItem(item.label, this.checkAutoFocus);
    this.$emit("finalSelected", this.$data.showSelected);
    if (this.$data.showSelected.length == 1) this.$data.displayList = true;
  }
  
}
